import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import * as Ui from './GridMenu.styles';
import 'react-loading-skeleton/dist/skeleton.css';
const SKELETON_COUNT = 8;

const GridMenu = ({ items, className, loading }) => (
  <Ui.Grid className={className}>
    {loading
      ? Array.from({ length: SKELETON_COUNT }, (_, i) => (
          <Ui.Card key={i}>
            <Ui.Title>
              <Skeleton width="75%" />
            </Ui.Title>
            <Ui.IconWrapper>
              <Skeleton width={150} height={200} />
            </Ui.IconWrapper>
          </Ui.Card>
        ))
      : items.map(({ key, label, Icon, onClick }) => (
          <Ui.Card key={key} onClick={onClick} role="button">
            <Ui.Title>{label}</Ui.Title>
            <Ui.IconWrapper>
              <Icon />
            </Ui.IconWrapper>
          </Ui.Card>
        ))}
  </Ui.Grid>
);

GridMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      Icon: PropTypes.elementType.isRequired,
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default GridMenu;
